import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-edit-data-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatDividerModule,
  ],
  templateUrl: './edit-data-dialog.component.html',
  styleUrl: './edit-data-dialog.component.css',
})
export class EditDataDialogComponent {
  // Variables
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  selectedDates: string[];
  handler: () => Observable<any>;
  snackBar: any;
  successMessage: string;

  // Constructor
  constructor(
    public dialogRef: MatDialogRef<EditDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      confirmText: string;
      cancelText: string;
      handler: () => Observable<any>;
      selectedDates: string[];
      successMessage: string;
    }
  ) {
    // Obtener los datos del dialogo
    this.title = data.title;
    this.message = data.message;
    this.confirmText = data.confirmText;
    this.cancelText = data.cancelText;
    this.handler = data.handler;
    this.selectedDates = data.selectedDates;
    this.successMessage = data.successMessage;
  }

  // Metodo para abrir el snackbar
  private _snackBar = inject(MatSnackBar);

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 7000,
    });
  }

  // Función para eliminar
  deleteSelected() {
    this.handler().subscribe({
      next: () => {
        this.dialogRef.close(true);
        this.openSnackBar(this.successMessage, 'Cerrar');
      },
      error: (error) => {
        this.dialogRef.close(false);
        this.openSnackBar('Error al eliminar', 'Cerrar');
        console.error('Error al eliminar:', error);
      },
    });
  }

  onCancel() {
    this.dialogRef.close(false);
    // console.debug(this.selectedDates);
  }
}
